document.addEventListener("DOMContentLoaded", function () {
    const lottieElements = document.querySelectorAll(".rtb-lottie");

    const isMobile = window.matchMedia("(max-width: 768px)").matches;

    if (isMobile) {
        const observer = new IntersectionObserver((entries, observer) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    const el = entry.target;
                    if (el) {
                        el.play();
                        observer.unobserve(el);
                    }
                }
            });
        }, {
            threshold: 0.2
        });

        lottieElements.forEach(el => observer.observe(el));

    } else {
        lottieElements.forEach(el => {
            el.addEventListener("mouseenter", function () {
                el.stop();
                el.play();
            });
        });
    }
});

